import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Trust from "@/components/landing/Trust";
import HelpHub from "@/components/landing/HelpHub";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>NextInvoice – Modulare Geschäftssoftware für KMU</title>
        <meta name="description" content="NextInvoice ist die modulare Geschäftssoftware für Selbstständige und KMU. Rechnungen, CRM, Lager, Personal – alles in einem System. 30 Tage kostenlos testen." />
        <link rel="canonical" href="https://nxtinvoice.de/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "NextInvoice",
          "url": "https://nxtinvoice.de",
          "description": "Modulare Geschäftssoftware für KMU – Rechnungen, CRM, Lager, Personal und mehr.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Hauptstraße 56",
            "addressLocality": "Neugersdorf",
            "postalCode": "02727",
            "addressRegion": "Sachsen",
            "addressCountry": "DE"
          },
          "contactPoint": [
            { "@type": "ContactPoint", "telephone": "+4915565350880", "contactType": "sales", "availableLanguage": "German" },
            { "@type": "ContactPoint", "email": "support@nxtinvoice.de", "contactType": "customer support", "availableLanguage": "German" }
          ]
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "NextInvoice",
          "url": "https://nxtinvoice.de",
          "inLanguage": "de-DE"
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SiteNavigationElement",
          "name": ["Module", "Preise", "Konfigurator", "Branchen", "Über uns"],
          "url": [
            "https://nxtinvoice.de/features",
            "https://nxtinvoice.de/preise",
            "https://nxtinvoice.de/konfigurator",
            "https://nxtinvoice.de/branchen",
            "https://nxtinvoice.de/ueber-uns"
          ]
        })}</script>
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Features />
        <Trust />
        <HelpHub />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
